class ProductQuality extends HTMLElement {
    constructor() {
        super();
        this.productUrl = this.getAttribute('data-product-url');
    }

    connectedCallback() {
        document.addEventListener('teeinblue-event-variant-changed', (event) => {
            if (!event.detail || !event.detail.variantId) {
                return;
            }
            fetch(`${this.productUrl}?variant=${event.detail.variantId}&section_id=product-quality`)
                .then(data => data.text())
                .then(data => {
                    const html = new DOMParser().parseFromString(data, 'text/html').querySelector('product-quality');
                    if (html && this.innerHTML != html.innerHTML) {
                        this.innerHTML = html.innerHTML;
                    }
                })
        })
    }
}

customElements.define('product-quality', ProductQuality);

